import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuService } from '@shared/services/menu.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html'
})
export class LandingComponent implements OnInit {
  @Input() menuItems!: MenuItem[];

  home!: MenuItem;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.initBreadCrumb();
  }

  private initBreadCrumb() {
    this.home = {
      label: 'Home',
      icon: 'fa-solid fa-house',
      routerLink: '/'
    };
  }

  setMenuItems(sidebarMenuItems: MenuItem[]) {
    console.log(sidebarMenuItems);

    this.menuItems = this.menuService.getBreadCrumbHierarchyFromCurrentUrl(
      sidebarMenuItems,
      this.router.routerState.snapshot.url
    );
  }
}
